import React from "react";
import { UserData } from "../../../Context/DataContext";
import styles from "./styles/Subscription.module.css";
import Products from "../../Payment/Products";
import { useNavigate } from "react-router-dom";
function AddNewPlan() {
  const userData = UserData();
  const navigate = useNavigate();

  return (
    <div className={styles.main}>
      <Products
        subscPlan={userData.BillingData.plan_name}
        currency={userData?.currency?.code}
        selected={userData?.BillingData?.plan}
        setSelected={() => {
          navigate("/user/plan");
        }}
        isSubscriptionPage={true}
      />
    </div>
  );
}
export { AddNewPlan };
